import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FullCalendar from '@fullcalendar/react';
import DropdownFilter from 'componentes/common/DropdownFilter.js';
import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import {
  Button,
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import MyModal from 'helpers/MyModal.js';
import EventsList from 'pages/Operations/EventsList.js';
import BtnExportToExcell from 'componentes/generic/ExportToExcel.js';
import { FormatTime } from 'helpers/FormatData';
const URI = ApiEndpoint + 'operations/';
const Calendar = () => {
  const calendarRef = useRef();
  const Auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  var userData = Auth.getSessionData();
  const [data, setData] = useState([]);
  const [dataToExport, setDataToExport] = useState([]);

  const [calendarApi, setCalendarApi] = useState({});

  const [currentFilter, setCurrentFilter] = useState('Mes');

  const [title, setTitle] = useState('Mes');
  const [openModalDay, setOpenModalDay] = useState(false);
  const [selectedDate, setSelectedDate] = useState(false);
  const [periodVisible, setPeriodVisible] = useState(false);
  const [customRange, setCustomRange] = useState({
    start: new Date(),
    end: new Date()
  });
  const previousRange = useRef({ start: null, end: null });

  const safeGetCalendarData = (start, end) => {
    const prev = previousRange.current;
    if (
      prev.start?.getTime() === start.getTime() &&
      prev.end?.getTime() === end.getTime()
    ) {
      return;
    }
    previousRange.current = { start, end };
    getCalendarData(start, end);
  };
  const handleCloseModalDay = () => {
    setOpenModalDay(false);
  };
  const handleEventClick = info => {
    if (info.event.url) {
      window.open(info.event.url);
      info.jsEvent.preventDefault();
    } else {
      console.log('info', info.event.start);
      setSelectedDate(info.event.start);
      setOpenModalDay(true);
      // setModalEventContent(info);
      // setIsOpenEventModal(true);
    }
  };

  const getCalendarData = async (dateFrom, dateTo) => {
    setData(null);
    setIsLoading(true);
    setDataToExport(null);
    httpClient(
      'POST',
      URI + 'calendar/',
      {
        from: dateFrom,
        to: dateTo
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          let dataReport = response.data;
          const renamedData = dataReport.map(item => ({
            Fecha: new Date(item.start).toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            }),
            Hora: FormatTime(item.start),
            Expediente: item.title.split('|')[0],
            Consumidor: item.title.split('|')[1].split('-')[0],
            Delegacion: item.location,
            Formato: item.formato,
            Folio: item.folioext,
            Pedido: item.numeropedido,
            motivo: item.description
          }));
          setDataToExport(renamedData);
          const eventList = response.data.reduce(
            (acc, event) =>
              event.schedules
                ? acc.concat(event.schedules.concat(event))
                : acc.concat(event),
            []
          );
          const normalized = eventList.map(
            ({ classname, start, end, ...rest }) => ({
              ...rest,
              className: classname,
              start: new Date(start.replace('Z', '')),
              end: new Date(end.replace('Z', ''))
            })
          );
          setData(normalized);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const viewMap = {
    Mes: 'dayGridMonth',
    Semana: 'listWeek'
    //Personalizado: 'CustomView'
  };

  const handleNavigate = direction => {
    if (!calendarApi || !calendarApi.getCurrentData) return;

    // Let FullCalendar do the navigation
    if (direction === 'next') {
      calendarApi.next();
    } else {
      calendarApi.prev();
    }
  };

  const handleFilter = filter => {
    if (!calendarApi) return;
    if (filter === 'Personalizado') {
      setPeriodVisible(true);
      setCustomRange({
        start: new Date(),
        end: new Date()
      });
      return;
    }
    setPeriodVisible(false);
    setCurrentFilter(filter);
    const view = viewMap[filter] || 'dayGridMonth';
    calendarApi.changeView(view);
    const { viewTitle } = calendarApi.getCurrentData().dateProfile;
    setTitle(viewTitle);
    // getCalendarData(activeRange.start, activeRange.end);
  };

  const eventTimeFormat = {
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: false,
    meridiem: true
  };

  const EventItem = ({ info }) => {
    const { event } = info;

    return (
      <>
        {info.view.type == 'listWeek' ? (
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="me-2">
                <span className="fw-bold">{event.title}</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <div className="me-2">
              <span className="fw-bold">{event.title.substring(0, 12)}</span>
            </div>
          </div>
        )}
      </>
    );
  };

  EventItem.propTypes = {
    info: PropTypes.object
  };
  useEffect(() => {
    if (
      calendarRef.current &&
      typeof calendarRef.current.getApi === 'function'
    ) {
      const api = calendarRef.current.getApi();
      setCalendarApi(api);
      const { activeRange, viewTitle } = api.getCurrentData().dateProfile;
      setTitle(viewTitle);
      getCalendarData(activeRange.start, activeRange.end);
    }
  }, []);
  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center gx-0">
            <Col xs="auto" className="d-flex justify-content-end order-md-1">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
                    Anterior
                  </Tooltip>
                }
              >
                <Button
                  variant="link"
                  className="icon-item p-0 me-1 ms-md-2"
                  onClick={() => {
                    handleNavigate('prev');
                  }}
                >
                  <FontAwesomeIcon icon="arrow-left" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip style={{ position: 'fixed' }} id="previousTooltip">
                    Siguiente
                  </Tooltip>
                }
              >
                <Button
                  variant="link"
                  className="icon-item p-0 me-lg-2"
                  onClick={() => handleNavigate('next')}
                >
                  <FontAwesomeIcon icon="arrow-right" />
                </Button>
              </OverlayTrigger>
            </Col>
            <Col xs="auto" className="d-flex justify-content-end order-md-2">
              <h4 className="mb-0 fs-9 fs-sm-8 fs-lg-7">
                {title || `${calendarApi.currentDataManager?.data?.viewTitle}`}
              </h4>
            </Col>

            <Col md="auto" className="d-md-none">
              <hr />
            </Col>
            {/* {periodVisible && (
              <Col className="d-flex justify-content-end order-md-2">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
                      Cambiar Periodo
                    </Tooltip>
                  }
                >
                  <Button
                    variant="link"
                    className="icon-item p-0 me-1 ms-md-2"
                    onClick={() => {
                      handleFilter('Mes');
                    }}
                  >
                    <FontAwesomeIcon icon="arrow-left" />
                  </Button>
                </OverlayTrigger>
                <DateRange
                  setDateFrom={setDateFrom}
                  setDateTo={setDateTo}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                />
                <Button
                  variant="link"
                  id="personalizedFilter"
                  className="icon-item p-0 me-1 ms-md-2"
                  onClick={() => {
                    if (dateFrom && dateTo && calendarRef.current) {
                      console.log('dateFrom', dateFrom, 'dateTo', dateTo);
                      const calendarApi = calendarRef.current.getApi();

                      calendarApi.setOption('visibleRange', {
                        start: dateFrom,
                        end: dateTo
                      });
                      calendarApi.changeView('listMonth');
                      calendarApi.gotoDate(dateFrom);
                      setCustomRange({
                        start: dateFrom,
                        end: dateTo
                      });
                    }
                  }}
                >
                  <FontAwesomeIcon icon="zoom" />
                </Button>
              </Col>
            )} */}
            {!periodVisible && (
              <Col className="d-flex justify-content-end order-md-2">
                <DropdownFilter
                  className="me-2"
                  filters={Object.keys(viewMap)}
                  currentFilter={currentFilter}
                  handleFilter={handleFilter}
                  icon="sort"
                  right
                />
                <BtnExportToExcell
                  dataReport={dataToExport}
                  fileName="Agenda por Periodo"
                />
              </Col>
            )}
          </Row>
        </Card.Header>
        <Card.Body className="p-0 app-calendar">
          <FullCalendar
            ref={calendarRef}
            headerToolbar={false}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin
            ]}
            views={{
              dayGridMonth: {},
              timeGridWeek: {},
              listWeek: {},
              list: {
                type: 'list',
                duration: { days: 8 }, // 8-day duration
                buttonText: 'Semana'
              },
              CustomView: {
                type: 'dayGridMonth',
                buttonText: 'Personalizado'
              }
            }}
            visibleRange={() => {
              if (calendarApi?.view?.type === 'CustomView') {
                return {
                  start: customRange.start,
                  end: customRange.end
                };
              }
              return null;
            }}
            eventContent={info => <EventItem info={info} />}
            weekends={true}
            initialView="dayGridMonth"
            themeSystem="bootstrap"
            locale={'es'}
            dayMaxEvents={2}
            height={800}
            stickyHeaderDates={false}
            editable
            eventOverlap={true}
            selectable
            selectMirror
            eventLimit={true}
            datesSet={arg => {
              setTitle(arg.view.title);
              safeGetCalendarData(arg.start, arg.end);
            }}
            select={info => {
              console.log('info', info);
              // setIsOpenScheduleModal(true);
              // setScheduleStartDate(info.start);
              // setScheduleEndDate(info.end);
            }}
            eventTimeFormat={eventTimeFormat}
            eventClick={handleEventClick}
            events={data || []}
          />
        </Card.Body>
      </Card>
      {openModalDay && (
        <MyModal
          id="id_myModal"
          title={'Lista de Eventos '}
          openModal={openModalDay}
          closeModal={handleCloseModalDay}
        >
          <EventsList selectedDate={selectedDate}></EventsList>
        </MyModal>
      )}
      {isLoading && (
        <div className="loader-overlay">
          <span className="loader">Cargando Eventos...</span>
        </div>
      )}
    </>
  );
};

export default Calendar;
